export const CURRENCY_CODES = ['USD', 'GBP', 'CAD', 'NGN'];
// Locale per currency so the right symbol + grouping render ($, £, CA$, ₦).
// All four are 2-decimal currencies, so the fraction digits below are correct.
const CURRENCY_LOCALE = {
    USD: 'en-US',
    GBP: 'en-GB',
    CAD: 'en-CA',
    NGN: 'en-NG',
};
export const toCents = (dollars) => Math.round(dollars * 100);
export const fromCents = (cents) => cents / 100;
export const formatMoney = (cents, currency = 'USD') => new Intl.NumberFormat(CURRENCY_LOCALE[currency] ?? 'en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}).format(fromCents(cents));
//# sourceMappingURL=money.js.map